/**
 * Spinner-Primitive — bewegter Ladeindikator für Aktionen, die spürbar dauern.
 *
 * Hintergrund (Issue #69): Ein Button, der beim Klick nur sein Label wechselt und
 * blass wird, sieht nach ~10 s aus wie eine eingefrorene Seite. Die Briefing-
 * Erzeugung braucht 75–87 s. Ohne Bewegung klicken Nutzer nach — genau das stand
 * im Log des Vorfalls (zweiter Klick 53 s nach dem ersten).
 *
 * Bewusst als eigenständiges Primitive, nicht inline im Button: Es gab im Projekt
 * bis hierher KEINEN Ladeindikator (kein `animate-spin` im Code). Der nächste
 * Langläufer soll ihn mitbenutzen können, statt eine zweite Variante zu erfinden.
 *
 * `currentColor` statt fester Farbe: Der Spinner erbt die Textfarbe seines
 * Kontexts und funktioniert damit auf dem Primary-Button (helle Schrift) genauso
 * wie auf einer Karte (dunkle Schrift) — ohne Tone-Prop und ohne Theme-Sonderfall.
 *
 * `motion-reduce:animate-none`: Wer im Betriebssystem reduzierte Bewegung
 * eingestellt hat, bekommt den Ring ohne Drehung. Der Ring bleibt sichtbar (er
 * ist auch statisch als „hier passiert etwas" lesbar), nur die Rotation entfällt.
 */

export function Spinner({ size = 12, className = '' }: { size?: number; className?: string }) {
  return (
    <span
      // aria-hidden: Der Zustand wird über das Button-Label und aria-busy am
      // Button transportiert. Ein zusätzlicher Screenreader-Treffer für die
      // reine Grafik wäre Lärm.
      aria-hidden="true"
      className={`inline-block rounded-full animate-spin motion-reduce:animate-none ${className}`}
      style={{
        width: size,
        height: size,
        // Ringtechnik: umlaufender halbtransparenter Rand, EIN Segment deckend.
        // Beim Drehen entsteht daraus der klassische Fortschrittsbogen.
        border: '2px solid currentColor',
        borderTopColor: 'transparent',
        opacity: 0.9,
        // Optische Grundlinie: ohne Korrektur sitzt der Kreis minimal zu hoch
        // neben Text derselben Größe.
        verticalAlign: '-0.125em',
      }}
    />
  );
}
